<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xoHUI6/tc-custom/9781635768572.jpg?1718071477671" alt="This image is the cover for the book Talking with Serial Killers: World's Most Evil, Talking with Serial Killers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Talking with Serial Killers: World's Most Evil, Talking with Serial Killers
      </h1>
      <p class="bookDescription body article font2">
        <b>A deep dive into the murders and minds of John Wayne Gacy, Kenneth Bianchi, William Heirens, John Cannan, and Patricia Wright from the bestselling author.</b><br/><br/>In <i>Talking with Serial Killers: World’s Most Evil</i>, bestselling author and criminologist Christopher Berry-Dee delves deeper into the gloomy underworld of killers and their crimes. He examines, with shocking detail and clarity, the lives and lies of people who have killed and shines a light on the motives behind their horrific crimes. Through interviews with the killers, the police, and key members of the prosecution, alongside careful analysis of the cases themselves, the reader is given unprecedented insight into the most diabolical minds that humanity has to offer. Extending from lonesome outsiders to upstanding members of the community, <i>Talking with Serial Killers: World’s Most Evil </i>shows that the world’s most monstrous killers may be far closer than you think.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Berry-Dee
      </h2>
      
      <p class="authorDescription body article">Born in 1948, Christopher Berry-Dee is descended from Dr. John Dee, Court Astrologer to Queen Elizabeth I, and is the founder and former Director of the Criminology Research Institute (CRI), and former publisher and Editor-in-Chief of The Criminologist, a highly respected journal on matters concerning all aspects of criminology from law enforcement to forensic psychology.   Christopher has interviewed and interrogated over thirty of the world’s most notorious killers—serial, mass and one-off—including Peter Sutcliffe, Ted Bundy, Aileen Wuornos, Dennis Nilsen and Joanne Dennehy. He was co-producer/interviewer for the acclaimed twelve-part TV documentary series The Serial Killers, and has appeared on television as a consultant on serial homicide, and, in the series Born to Kill?, on the cases of Fred and Rose West, the Moors Murderers and Dr. Harold Shipman. He has also assisted in criminal investigations as far afield as Russia and the United States.   Notable book successes include: Monster (basis for the movie of the same title, about Aileen Wuornos); and the internationally bestselling Talking with Serial Killers and Talking with Psychopaths series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?015ef878